module.exports = __webpack_public_path__ + "img/banner.20723efe.png";